if (typeof window.quickAddToCart === 'undefined') {
  window.quickAddToCart = function (event, button) {
    event.preventDefault()
    event.stopPropagation()

    if (button.disabled) return

    const variantId = button.dataset.variantId
    const inventory = parseInt(button.dataset.inventory || 0)
    const policy = button.dataset.policy
    const management = button.dataset.management

    const inCart = window.cartQuantities?.[variantId] || 0
    let availableToAdd = Infinity

    if (management === 'shopify' && policy === 'deny') {
      availableToAdd = Math.max(0, inventory - inCart)
    }

    if (availableToAdd <= 0) {
      button.disabled = true
      button.title = inCart > 0 ? 'Máximo en carrito' : 'Agotado'
      return
    }

    const icon = button.querySelector('.cart-icon')
    const spinner = button.querySelector('.loading-spinner')
    icon.classList.add('hidden')
    spinner.classList.remove('hidden')
    button.disabled = true

    const formData = new FormData()
    formData.append('id', variantId)
    formData.append('quantity', 1)
    formData.append('sections', 'header')

    fetch('/cart/add.js', {
      method: 'POST',
      body: formData,
      headers: { 'X-Requested-With': 'XMLHttpRequest' },
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.status) {
          const errorDesc = (data.description || '').toLowerCase()
          const isStockError =
            errorDesc.includes('maximum quantity') ||
            errorDesc.includes('inventory') ||
            errorDesc.includes('available')

          if (isStockError) {
            fetch('/cart.js')
              .then((r) => r.json())
              .then((cart) => {
                if (window.cartDrawerInstance) {
                  window.cartDrawerInstance.updateCartQuantities(cart)
                }
                icon.classList.remove('hidden')
                spinner.classList.add('hidden')
                button.disabled = true
                button.title = 'Máximo alcanzado'
              })
          } else {
            icon.classList.remove('hidden')
            spinner.classList.add('hidden')
            button.disabled = false
          }
        } else {
          if (window.cartQuantities) {
            window.cartQuantities[variantId] = (window.cartQuantities[variantId] || 0) + 1
          }

          fetch('/cart.js')
            .then((r) => r.json())
            .then((cart) => {
              document.dispatchEvent(
                new CustomEvent('cart:item-added', {
                  detail: { cart },
                })
              )

              document.dispatchEvent(
                new CustomEvent('cart:updated', {
                  detail: {
                    cart,
                    changeType: 'item_added',
                    productsChanged: true,
                  },
                })
              )

              if (window.cartDrawerInstance) {
                window.cartDrawerInstance.renderCart(data)
                window.cartDrawerInstance.open()
              }

              updateQuickAddButtons()

              icon.classList.remove('hidden')
              spinner.classList.add('hidden')
              button.disabled = false
            })
        }
      })
      .catch(() => {
        icon.classList.remove('hidden')
        spinner.classList.add('hidden')
        button.disabled = false
      })
  }

  window.updateQuickAddButtons = function () {
    document.querySelectorAll('.quick-add-btn').forEach((button) => {
      const variantId = button.dataset.variantId
      const inventory = parseInt(button.dataset.inventory || 0)
      const policy = button.dataset.policy
      const management = button.dataset.management
      const inCart = window.cartQuantities?.[variantId] || 0

      let availableToAdd = Infinity
      if (management === 'shopify' && policy === 'deny') {
        availableToAdd = Math.max(0, inventory - inCart)
      }

      if (availableToAdd <= 0) {
        button.disabled = true
        button.title = inCart > 0 ? 'Máximo en carrito' : 'Agotado'
      } else {
        button.disabled = false
        button.title = 'Agregar al carrito'
      }
    })
  }

  window.updateWishlistIcons = function () {
    const wishlist = JSON.parse(localStorage.getItem('user_wishlist')) || []
    document.querySelectorAll('.js-wishlist-btn').forEach((btn) => {
      btn.classList.toggle('is-active', wishlist.includes(btn.dataset.handle))
    })
  }

  document.addEventListener('click', function (e) {
    const btn = e.target.closest('.js-wishlist-btn')
    if (!btn) return

    const handle = btn.dataset.handle
    let wishlist = JSON.parse(localStorage.getItem('user_wishlist')) || []

    if (wishlist.includes(handle)) {
      wishlist = wishlist.filter((id) => id !== handle)
    } else {
      wishlist.push(handle)
    }

    localStorage.setItem('user_wishlist', JSON.stringify(wishlist))
    window.updateWishlistIcons()
  })

  document.addEventListener('DOMContentLoaded', function () {
    updateQuickAddButtons()
    updateWishlistIcons()
  })

  document.addEventListener('cart:updated', updateQuickAddButtons)
  document.addEventListener('cart:quantity-changed', updateQuickAddButtons)
  document.addEventListener('cart:item-added', updateQuickAddButtons)
}
